import getField from '@form/formGenerator'

export const scanPhotoSaveUrl = `${import.meta.env.VITE_API_URL}/api/scan-photos`

export const scanPhotoFormObject = {
  id: null,
  units: 0,
  eggs: 0,
  birds: 0,
  sterilizationCall: null,
  mission: null,
  scanPhoto: null,
  isTreated: 0,
  releatedPhoto: null,
  missionSubject: ''
}

export const scanPhotoFormFields = (
  scanPhotoFormObject,
  updateFormObject,
  updateFormObjectProp,
  saveForm,
  errors,
  isLoading,
  t,
  creationModalCaller,
  missionSubjects,
  generateCallUnits
) => {
  const selectedMissionSubject = scanPhotoFormObject.missionSubject && missionSubjects.length
    ? missionSubjects.filter(subject => {
      return subject.id === parseInt(scanPhotoFormObject.missionSubject)
    })[0]
    : null

  const fields = [
    {
      type: 'select',
      name: 'missionSubject',
      label: t('form.captured_target'),
      key: 'scanPhotoFormObject-missionSubject',
      cssClass: 'column is-12',
      options: missionSubjects,
      canCreate: true,
      creationModalCaller: () => creationModalCaller('missionSubject', 'missionSubjects'),
      isMultiple: true,
      value: scanPhotoFormObject.missionSubject,
      isRequired: true
    },
    {
      type: 'number',
      name: 'units',
      label: selectedMissionSubject?.config.withChicks ? t('form.nests') : t('form.units'),
      value: scanPhotoFormObject.units,
      key: 'scanPhotoFormObject-units',
      cssClass: `column is-4 ${!selectedMissionSubject ? 'is-hidden' : (selectedMissionSubject?.config.withUnits ? '' : 'is-hidden')}`
    },
    {
      type: 'number',
      name: 'birds',
      label: t('form.birds'),
      value: scanPhotoFormObject.birds,
      key: 'scanPhotoFormObject-birds',
      cssClass: `column is-4 ${!selectedMissionSubject ? 'is-hidden' : (selectedMissionSubject.config.withChicks ? '' : 'is-hidden')}`
    },
    {
      type: 'number',
      name: 'eggs',
      label: t('form.eggs'),
      value: scanPhotoFormObject.eggs,
      key: 'scanPhotoFormObject-eggs',
      cssClass: `column is-4 ${!selectedMissionSubject ? 'is-hidden' : (selectedMissionSubject.config.withEggs ? '' : 'is-hidden')}`
    },
    {
      type: 'switcher',
      name: 'isGlobalVue',
      label: t('form.is_global_vue'),
      value: scanPhotoFormObject.isGlobalVue,
      cssClass: 'column is-12',
      key: 'scanPhotoFormObject-isGlobalVue',
      id: `isGlobalVue-${scanPhotoFormObject.id ?? 'new'}`,
    },
    {
      type: 'switcher',
      name: 'isTreated',
      label: t('form.is_treated'),
      value: scanPhotoFormObject.isTreated,
      cssClass: 'column is-12',
      key: 'scanPhotoFormObject-isTreated',
      id: `isTreated-${scanPhotoFormObject.id ?? 'new'}`,
    },
    {
      type: 'function',
      callback: generateCallUnits,
      cssClass: 'call-units',
      key: 'scanPhotoFormObject-releated-units',
    },
    {
      type: 'textarea',
      name: 'comment',
      label: t('form.comment'),
      value: scanPhotoFormObject.comment ?? '',
      key: 'scanPhotoFormObject-comment',
      cssClass: `column is-12 ${1 !== parseInt(scanPhotoFormObject.isTreated) ? '' : 'is-hidden'}`
    },
    {
      type: 'file',
      name: 'scanPhoto',
      cssClass: 'column is-12 scanPhoto',
      key: 'scanPhotoFormObject-scanPhoto',
      label: t('form.photo'),
      targetUrl: `${import.meta.env.VITE_API_URL}/api/push/temp-files`,
      blobPoster: scanPhotoFormObject.scanPhoto,
      id: `scanPhoto-${scanPhotoFormObject.id ?? 'new'}`,
      isRequired: true
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'scanPhotoFormObject-form',
      isLoading,
      disabled: scanPhotoFormObject.scanPhoto ? false : true
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(scanPhotoFormObject.id),
      key: 'scanPhotoFormObject-id'
    },
    {
      type: 'hidden',
      name: 'sterilizationCall',
      value: parseInt(scanPhotoFormObject.sterilizationCall),
      key: 'scanPhotoFormObject-sterilizationCall'
    },
    {
      type: 'hidden',
      name: 'mission',
      value: parseInt(scanPhotoFormObject.mission),
      key: 'scanPhotoFormObject-mission'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}